import { ContactPersonType } from "@/stores/order/types.ts";
import { CustomerType, State } from "./types";
/*
 * define state here
 */
export default (): State => ({
  directOrder: {
    trip: {},
    org_id: "",
    timezone: "",
    order_id: "",
    gen_oid: "",
    contact_person: {} as ContactPersonType,
    state: undefined,
    total_price_ex_vat: 0,
    total_price_inc_vat: 0,
    external_trip_ref: null,
    editedTripIds: [],
    cancel_trips: [],
    additional_items: [],
    customer: {} as CustomerType,
  },
  errors: {},
});
